import AsyncStorage from '@react-native-async-storage/async-storage';

export const initSecureStorage = () => Promise.resolve();

export const secureStorage = AsyncStorage;
